// MAINTENANCE: Delete this entire file if it is not needed when maintenance is complete
import { Alert, AlertTitle, Button, Dialog, DialogActions } from '@mui/material'
import { t } from 'i18next'
import moment from 'moment-timezone'
import { useState } from 'react'
import {
	MAINTENANCE_END,
	MAINTENANCE_START,
	TIMEZONE,
	getExpectedCompletionText,
	getMaintenanceWindowText
} from './config'

const MaintenanceDialog = () => {
	const [isDismissed, setIsDismissed] = useState(false)

	const now = moment().tz(TIMEZONE)

	const handleDismiss = () => {
		setIsDismissed(true)
	}

	// Phase 1: Before maintenance (can be dismissed)
	if (now.isBefore(MAINTENANCE_START) && !isDismissed) {
		return (
			<Dialog open={true} onClose={handleDismiss}>
				<Alert severity="warning">
					<AlertTitle>{t('app:Maintenance.upcoming.title')}</AlertTitle>
					{t('app:Maintenance.upcoming.message')}
					<br />
					<br />
					<strong>{getMaintenanceWindowText()}</strong>
					<DialogActions sx={{ padding: 0 }}>
						<Button onClick={handleDismiss} color="primary">
							{t('app:Generic.OK')}
						</Button>
					</DialogActions>
				</Alert>
			</Dialog>
		)
	}

	// Phase 2: During maintenance
	else if (
		now.isBefore(MAINTENANCE_END) &&
		!isDismissed
	) {
		return (
			<Dialog open={true} disableEscapeKeyDown>
				<Alert severity="error">
					<AlertTitle>{t('app:Maintenance.during.title')}</AlertTitle>
					{t('app:Maintenance.during.message')}
					<br />
					<br />
					<strong>{getExpectedCompletionText()}</strong>
					<DialogActions sx={{ padding: 0 }}>
						<Button onClick={handleDismiss} color="primary">
							{t('app:Generic.OK')}
						</Button>
					</DialogActions>
				</Alert>
			</Dialog>
		)
	}

	// Phase 3: After maintenance (hide alert)
	return null
}

export default MaintenanceDialog
